import {
  Toast,
} from 'vant';
const pay = (res) => {
  return new Promise((resolve, reject) => {
    Toast.loading({
      message: '',
      duration: 3000,
      loadingType: 'spinner',
      className: 'toast-no-dialog'
    })
    // wx.config({
    //   appId: res.appid,
    //   timestamp: res.timeStamp,
    //   nonceStr: res.nonce_str,
    //   signature: sha1(
    //     `jsapi_ticket=${res.jsapiTicket}&noncestr=${res.nonce_str}&timestamp=${res.timeStamp}&url=${window.location.href.replace(/http:\/\//, '').replace(/https:\/\//, '')}`
    //   ),
    //   jsApiList: ["chooseWXPay"]
    // });
    let payData = {
      appId: res.appid,
      timeStamp: String(res.timeStamp),
      timestamp: String(res.timeStamp),
      nonceStr: res.nonce_str,
      package: `prepay_id=${res.prepay_id}`,
      signType: 'MD5',
      paySign: res.paySign,
    }
    WeixinJSBridge.invoke('getBrandWCPayRequest', payData,
        (res) => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            Toast.success('支付成功')
            resolve()
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else {
            Toast.fail('支付失败')
            reject()
          }
        })
    // wx.ready(function () {
    //   Toast.clear()
    //   wx.chooseWXPay({
    //     ...payData,
    //     success: function (res) {
    //       // 支付成功后的回调函数
    //       console.log(res)
    //       resolve(res)
    //     },
    //     fail(err) {
    //       console.log(err)
    //       Toast('取消支付')
    //       reject(err)
    //     }
    //   });
    // });
  })
}

export default pay